export interface WithdrawalDocumentDiagnosticFormValues {
  withdrawalDate: string;
  materialNumber: string;
  materialText: string;
  materialType: string;
  storageAddress: string;
  quantityRemoved: string;
  currentStock: string;
  persons: string[];
  accountingNumber: string;
  accountingDescription: string;
  orderInfo: string;
}

export interface WithdrawalDocumentOverlayMetrics {
  width: number;
  height: number;
  scale: number;
  date_probe_ink_pixels: number;
  source_ink_pixels: number;
  alpha_nontransparent_pixels: number;
  alpha_max: number;
  overlay_png_bytes?: number;
}

export interface WithdrawalDocumentPreviewMetrics {
  width: number;
  height: number;
  webp_bytes: number;
}

export interface WithdrawalDocumentDiagnostic {
  id: string;
  started_at: string;
  finished_at: string | null;
  status: "running" | "ok" | "error";
  mode: "artifacts" | "pdf" | "preview";
  app_version: string;
  artifact_version: string;
  user_agent: string;
  form_values: WithdrawalDocumentDiagnosticFormValues;
  template_bytes?: number;
  overlay?: WithdrawalDocumentOverlayMetrics;
  pdf_bytes?: number;
  preview?: WithdrawalDocumentPreviewMetrics;
  timings_ms?: {
    canonical_pdf?: number;
    pdfjs_flatten_render?: number;
    flattened_pdf_encode?: number;
    webp_encode?: number;
    total?: number;
  };
  error?: string;
}

const STORAGE_KEY = "materialentnahme:document-render-diagnostics:v1";
const MAX_ENTRIES = 20;
const UPDATED_EVENT = "materialentnahme:document-render-diagnostics-updated";

function readRaw(): WithdrawalDocumentDiagnostic[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed as WithdrawalDocumentDiagnostic[] : [];
  } catch {
    return [];
  }
}

function writeRaw(entries: WithdrawalDocumentDiagnostic[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
    window.dispatchEvent(new Event(UPDATED_EVENT));
  } catch {
    // Diagnose darf die Dokumentgeneration niemals blockieren.
  }
}

export function getWithdrawalDocumentDiagnostics(): WithdrawalDocumentDiagnostic[] {
  return readRaw();
}

export function saveWithdrawalDocumentDiagnostic(entry: WithdrawalDocumentDiagnostic): void {
  const entries = readRaw().filter((item) => item.id !== entry.id);
  entries.unshift(entry);
  writeRaw(entries);
}

export function clearWithdrawalDocumentDiagnostics(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(UPDATED_EVENT));
  } catch {
    // Best effort.
  }
}

export function withdrawalDocumentDiagnosticsUpdatedEvent(): string {
  return UPDATED_EVENT;
}
